import { PayloadAction, createSlice } from '@reduxjs/toolkit';
import { ICalculatorState, IFormState, IOption } from '../../types/calculator';

export const initialState: ICalculatorState = {
  displayAllFilters: false,
};

/* istanbul ignore next */
export const offerCalculatorSlice = createSlice({
  initialState,
  name: 'calculator',
  reducers: {
    setDisplayAllFilters: (state, action: PayloadAction<boolean>) => {
      state.displayAllFilters = action.payload;
    },
    setBankOptions: (state, action: PayloadAction<IOption[]>) => {
      state.banksOptions = action.payload;
    },
    setRegionsOptions: (state, action: PayloadAction<IOption[]>) => {
      state.regionsOptions = action.payload;
    },
    setDefaultFormState: (state, action: PayloadAction<Partial<IFormState>>) => {
      state.defaultFormState = action.payload;
    },
  },
});

export const { setDisplayAllFilters, setRegionsOptions, setBankOptions, setDefaultFormState } =
  offerCalculatorSlice.actions;
